import type { FaireProductEntity } from "../../entity_types/product";

export const p_rz2x2trnrr: FaireProductEntity = {
  token: "p_rz2x2trnrr",
  type: "product",
  name: "Peanuts Variety Snoopy 2Line Crew Ankle Socks",
  brandToken: "b_a2xtvyskxb",
  brandName: "K-Wonderland",
  imageUrl:
    "https://cdn.faire.com/fastly/18928f28262b8403d5b40d210adc8a3b102fc9890a1860f189cde3065e487c21.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af2ddd935194551f69a47a1eabf5e9b1cd5944b5221d1d2a1f4d0d4c3bdfb055.jpeg",
    "https://cdn.faire.com/fastly/f97f98fdce5c38a05b4fb87d01168ab423231219c0943e64e63f944beadb2110.jpeg",
    "https://cdn.faire.com/fastly/69ac4e89be4b7008f7dc8274569b8b56d3698e3af22745d8770655bd1bbec5bc.jpeg",
    "https://cdn.faire.com/fastly/4e1ef6b786160e835bd757a4e205be8dd950263813cdcc31d2997a91dbe53ef5.jpeg",
    "https://cdn.faire.com/fastly/1491567b7c5bfc78aa37b91b792ce70318216fa174575434a7036db9cd23967a.jpeg",
    "https://cdn.faire.com/fastly/ca190629def5d41b1a4d1fe00b50c2adcfb9653cfdf384e2cd2f359db9791397.jpeg",
    "https://cdn.faire.com/fastly/222cb5733ab9060c719aa8865d6d880f8611275851607187e3d7fc64992bd616.jpeg",
    "https://cdn.faire.com/fastly/c280080e1857c2153fd36f227249d80e34682f3455a7cc037b7ef6bd97d1de55.jpeg",
  ],
  priceDollars: 4.2,
  description:
    "These are New Theme Snoopy ankle socks.\nThe quality is high with the highest quality material.\nIt is highly valuable because it is a limited-time Series.\nIt is made of cotton with good elasticity and good sweat absorption, so it feels good to wear.\nSize: Free (recommended in US 3-9)\n\nMade in Korea",
  tags: [],
  msrpDollars: 8.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:30.734Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
